var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Btn',{staticClass:"position-relative follow-button ",class:[
    !_vm.isFollow ? _vm.followClass : _vm.showUnfollowText ? _vm.hoverClass : _vm.unfollowClass,
    _vm.waitingFollow ? 'is-loading' : '' ],attrs:{"label":_vm.followText,"variant":_vm.variant},nativeOn:{"click":function($event){return _vm.follow($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }